// React
import { ReactNode, useEffect, useState } from "react";

// MUI
import { FilterListIcon } from "@Layouts/components/Tables/DataSmartTable/toolbar/CustomIcons";
import Badge from "@mui/material/Badge";
import { ClickAwayListener, IconButton } from "@mui/material";
import { styled } from "@mui/material/styles";
import { errorLogger, getError } from "@/Common/helpers/logger";

const StyledBadge = styled(Badge)(({ theme }) => ({
	"& .MuiBadge-badge": {
		right: -3,
		top: 13,
		border: `2px solid ${theme.palette.background.paper}`,
		padding: "0 4px",
		backgroundColor: "#e41f75",
		fontFamily: "PTSansProNarrow",
	},
}));

type CustomStyledBadgeProps = {
	children: ReactNode;
	filterModel: {
		items: {
			columnField: string;
			operatorValue: string;
			value: string;
		}[];
	};
};

function CustomStyledBadge(props: Readonly<CustomStyledBadgeProps>) {
	const { filterModel } = props;
	const [badgeNumber, setBadgeNumber] = useState(0);

	useEffect(() => {
		let totalFilters = 0;
		try {
			if (filterModel?.items?.length) {
				filterModel.items.forEach((element) => {
					if (typeof element.value !== "undefined" && element.value) {
						totalFilters += 1;
					}
				});
			}
		} catch (error) {
			errorLogger(getError(error));
		}

		setBadgeNumber(totalFilters);
	}, [filterModel]);

	return (
		<StyledBadge badgeContent={badgeNumber} color="secondary">
			{props.children}
		</StyledBadge>
	);
}

type FilterButtonProps = {
	apiRef: {
		current: {
			showFilterPanel: () => void;
			hideFilterPanel: () => void;
			state: {
				filter: {
					filterModel: {
						items: {
							columnField: string;
							operatorValue: string;
							value: string;
						}[];
					};
				};
			};
		};
	};
	disabled: boolean;
	sx: object;
};
export default function FilterButton(props: Readonly<FilterButtonProps>) {
	const { apiRef } = props;
	const [showPanel, setShowPanel] = useState(false);

	const showFilterPanel = () => {
		setShowPanel(!showPanel);

		if (!showPanel) {
			props.apiRef.current.showFilterPanel();
		} else {
			props.apiRef.current.hideFilterPanel();
		}
	};

	return (
		<ClickAwayListener
			onClickAway={() => {
				setShowPanel(false);
			}}
		>
			{apiRef?.current && (
				<IconButton disabled={props.disabled} aria-label="filter" onClick={showFilterPanel} sx={props.sx}>
					{Boolean(apiRef?.current?.state?.filter) && (
						<CustomStyledBadge filterModel={apiRef.current.state.filter.filterModel || null}>
							<FilterListIcon />
						</CustomStyledBadge>
					)}
				</IconButton>
			)}
		</ClickAwayListener>
	);
}
